define('CustomProductCollection.Helper', [
    'CustomProductCollection.UrlHelper',
    'CustomProductCollection.PriceHelper',
    'CustomProductCollection.FacetHelper',
    'CustomProductCollection.RenderHelper'
], function CustomProductCollectionHelper(
    UrlHelper,
    PriceHelper,
    FacetHelper,
    RenderHelper
) {
    'use strict';

    /**
     * Composite helper module for Custom Product Collection.
     * Historically a mixed utility module, now serves as a proxy/adapter to
     * focused helpers for URL, price, facet, and render logic.
     *
     * New features and modules should prefer the specific helpers instead of this composite.
     * Maintained for backward compatibility within the extension ecosystem.
     * @module CustomProductCollection.Helper
     * @see CustomProductCollection.UrlHelper
     * @see CustomProductCollection.PriceHelper
     * @see CustomProductCollection.FacetHelper
     * @see CustomProductCollection.RenderHelper
     */

    return {
        getDecodedURLParameter: UrlHelper.getDecodedURLParameter,
        parseUrlOptions: UrlHelper.parseUrlOptions,
        getPriceRangeFromChildren: PriceHelper.getPriceRangeFromChildren,
        defineSearchMasterOptions: FacetHelper.defineSearchMasterOptions,
        setupMasterFacet: FacetHelper.setupMasterFacet,
        canRenderChildView: RenderHelper.canRenderChildView
    };
});
